import { Breadcrumbs } from "./Breadcrumbs";
import { LanguageToggle } from "./LanguageToggle";
import { ThemeToggle } from "./ThemeToggle";
import { UserMenu } from "./UserMenu";

export function Topbar() {
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center justify-between gap-2 border-b border-line bg-surface/85 px-3 backdrop-blur sm:gap-3 sm:px-6 lg:px-10 2xl:px-14">
      <Breadcrumbs />
      <div className="flex items-center gap-2">
        <LanguageToggle />
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
